"use client";

import BottomSection from "../Section/BottomSection";
import SectionWrapper from "../Section/SectionWrapper";
import TopSection from "../Section/TopSection";
import TeamMemberInfo from "./components/TeamMemberInfo";
import TeamMemberDetails from "./components/TeamMembersDetails/TeamMemberDetails";

const TeamMembers = ({ teamMembers }) => {
  return (
    <div className="bg-[#F3F7FF] mt-12 px-3">
      <SectionWrapper extraClass={"md:pt-32 pt-16 "}>
        <TopSection>
          <TeamMemberInfo />
        </TopSection>
        <BottomSection>
          <TeamMemberDetails teamMembers={teamMembers} />
        </BottomSection>
      </SectionWrapper>
    </div>
  );
};

export default TeamMembers;
